<template>
  <div v-if="!ready" class="min-h-screen grid place-items-center">
    <div class="grid-bg" />
    <div class="relative z-10 flex items-center gap-3 text-muted">
      <div class="w-5 h-5 rounded-full border-2 border-cyan border-t-transparent animate-spin" />
      Chargement de ta session...
    </div>
  </div>
  <template v-else>
    <router-view v-if="isAuthRoute" v-slot="{ Component, route }">
      <transition name="page" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
    <AppShell v-else>
      <router-view v-slot="{ Component, route }">
        <transition name="page" mode="out-in">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
    </AppShell>
  </template>
</template>

<script setup>
import { onBeforeMount, computed } from 'vue';
import { useRoute } from 'vue-router';
import AppShell from '@/components/layout/AppShell.vue';
import { useAuth, loadSession } from '@/composables/useAuth';

const route = useRoute();
const { ready } = useAuth();
const isAuthRoute = computed(() => route.meta?.layout === 'auth');

onBeforeMount(async () => {
  await loadSession();
});
</script>
